// @flow
export { default } from './Transcript';
